<template>
  <div class="pay-wrapper">
    <basis-nav nav-title="" :back="back" />
    <div class="form-wrapper">
      <basis-form
        :form-ref.sync="formRef"
        :keys-map="keysMap"
        :target="form"
      >
        <template v-slot:areas-wrapper="{columns, config}">
          <van-field
            v-model="columns[config.key]"
            :readonly="config.isClick"
            :clickable="config.isClick"
            :name="config.rulesName"
            :label="config.label"
            :type="config.type"
            :placeholder="config.placeholder"
            :rules="config.rules"
            @click.stop="config.isClick && clickPopupHandler(config.label)"
          />
        </template>
        <template v-slot:amount-input>
          <van-stepper v-model="form.amount" />
        </template>
      </basis-form>
    </div>
    <div class="submit-wrapper">
      <van-button
        v-if="commoditie.creditsNeeded !== null"
        class="button credits-button"
        native-type="submit"
        @click="clickSubmitHandler('credits')"
      >支付{{ creditsNeeded }}积分</van-button>
      <van-button
        v-if="commoditie.cashNeeded !== null"
        class="button cash-button"
        native-type="submit"
        @click="clickSubmitHandler('cash')"
      >支付 ¥ <span v-money="cashNeeded" /></van-button>
    </div>
    <div class="popup-wrapper">
      <!-- 地区选择 -->
      <van-popup v-model="showAreaPopup" position="bottom">
        <van-area
          :area-list="Areas"
          @confirm="onConfirm"
          @cancel="showAreaPopup = false"
        />
      </van-popup>
      <!-- 积分支付 -->
      <basis-credits-popup
        v-model="showCreditsPopup"
        :credits-needed="creditsNeeded"
        @pay="payHandler"
      />
    </div>
    <div class="overlay-wrapper">
      <wx-pay-overlay
        :overlay-status.sync="showWxPayOverlay"
        :qrcode="wxPayQrcode"
        @successed="$router.push({name: 'orders'})"
      />
    </div>
  </div>
</template>

<script>
import { BasisNav, BasisCreditsPopup, BasisForm } from '@/components/basis'
import WxPayOverlay from '@/components/wx'
import { isWechatBrowser, onBridgeReady } from '@/utils/wechat'
import { mapGetters, mapActions } from 'vuex'
import regVertify from '@/utils/regVertify'
import Areas from '@/data/Areas'
import { wxPayENV } from '@/config/wx.config'
import { Orders } from '@/api'
import { mixinWxShare } from '@/mixins'

export default {
  name: 'Pay',
  components: { BasisNav, BasisCreditsPopup, BasisForm, WxPayOverlay },
  mixins: [mixinWxShare],
  data: () => ({
    showAreaPopup: false,
    showCreditsPopup: false,
    showWxPayOverlay: false,
    Areas,
    keysMap: [
      {
        label: '收件人',
        key: 'name',
        rulesName: 'name',
        placeholder: '请填写收货人姓名',
        rules: [{ required: true, message: '缺少收货人姓名' }]
      },
      {
        label: '手机号码',
        type: 'tel',
        key: 'contact',
        rulesName: 'contact',
        placeholder: '请填写收货人手机号',
        rules: [
          { required: true, message: '缺少收货人手机号' },
          { validator: regVertify.mobile, message: '手机号码输入错误' }
        ]
      },
      {
        isClick: true,
        label: '所在地区',
        key: 'areas',
        rulesName: 'areas',
        placeholder: '省市区县、乡镇等',
        rules: [{ required: true, message: '请填写您的所在地区' }]
      },
      {
        label: '详细地址',
        type: 'textarea',
        key: 'detail',
        rulesName: 'detail',
        placeholder: '街道、楼牌号',
        rules: [{ required: true, message: '请填写您的详细地址' }]
      },
      {
        label: '购买数量',
        type: 'amount',
        key: 'amount',
        rulesName: 'amount'
      },
      {
        label: '备注',
        type: 'textarea',
        key: 'note',
        rulesName: 'note',
        placeholder: '备注信息'
      }
    ],
    form: {
      name: undefined,
      contact: undefined,
      areas: undefined,
      detail: undefined,
      amount: 1,
      note: undefined
    },
    formRef: undefined,
    payType: undefined,
    wxPayQrcode: ''
  }),
  computed: {
    ...mapGetters(['commoditie', 'user']),
    creditsNeeded () {
      const { amount } = this.form
      const { creditsNeeded } = this.commoditie
      return amount * creditsNeeded
    },
    cashNeeded () {
      const { amount } = this.form
      const { cashNeeded } = this.commoditie
      return amount * cashNeeded
    }
  },
  mounted () {
    for (const key in this.form) {
      if (
        Object.prototype.hasOwnProperty.call(this.form, key) &&
        key in this.user
      ) {
        this.form[key] = this.user[key]
      }
    }
  },
  methods: {
    ...mapActions(['updateAddress']),
    back () {
      this.$router.push({ name: 'commoditie-id', params: { id: this.commoditie.id }})
    },
    clickPopupHandler (type) {
      switch (type) {
        case '所在地区':
          console.log('click', type)
          this.showAreaPopup = true
          break
      }
    },
    onConfirm (areas) {
      this.form.areas = areas.map((item) => item.name).join('/')
      this.showAreaPopup = false
    },
    clickSubmitHandler (type) {
      this.payType = type
      this.formRef.validate().then(() => {
        this.updateAddress(this.form)
        this.onSubmit()
      })
    },
    onSubmit () {
      switch (this.payType) {
        case 'credits':
          this.showCreditsPopup = true
          break
        case 'cash':
          this.payHandler()
          break
      }
    },
    async payHandler (callback) {
      try {
        const { order: addedOrder } = await Orders.add({
          collection: 'commodities',
          resourceId: this.commoditie.id,
          data: this.form
        })
        const { wxPayPayload, wxPayQrcode, wxPayUrl } = await Orders.pay({
          id: addedOrder.id,
          payType: this.payType
        })
        if (this.payType === 'credits') {
          this.showCreditsPopup = false
          callback()
          this.$router.push({
            name: 'orders'
          })
        } else {
          switch (isWechatBrowser()) {
            case true:
              // 微信浏览器
              onBridgeReady(wxPayPayload).then(() => {
                this.$notify({ type: 'success', message: '支付成功' })
                this.$router.push({
                  name: 'orders'
                })
              }).catch(() => {
                this.$notify({ type: 'danger', message: '支付失败' })
              })
              break
            case false:
              // 普通浏览器
              this.showWxPayOverlay = true
              if (wxPayENV === 'NATIVE') {
                this.wxPayQrcode = wxPayQrcode
              } else {
                window.location = wxPayUrl
              }
              break
          }
        }
      } catch (error) {
        callback()
        console.log(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pay-wrapper {
  @include mh-bgc(100vh, #F4F4F4);
  .basis-form {
    padding: 0 16px;
    background-color: #fff;
    ::v-deep {
      .van-cell:after {
        left: 0;
      }
      .van-field+.van-field {
        margin-top: 0;
      }
    }
  }
  .submit-wrapper {
    @include bottomfix(32px, 0);
    padding: 0 16px;
    .button {
      font-size: $font-size-lg;
      & + .button {
        margin-top: 16px;
      }
      &:first-child {
        @include lg-radius(transparent, transparent, 4px);
        @include plain-button(100%, 39px);
      }
      &:last-child {
        @include lg-radius(#ECCEA2, #E7B170, 4px);
        @include normal-button(100%, 39px);
      }
    }
  }
}
</style>
